import { IBoardRankingGroup } from '../../../dtos/IBoardSnapshot';
import { formatWallClockTime } from '../../../utils/scheduleDate';
import { categoryLabel, modalityLabel } from '../../../utils/tournament/labels';

export { categoryLabel, modalityLabel };

export const groupKey = (group: IBoardRankingGroup): string =>
  `${group.tournament_modality_id}:${group.category}`;

export const groupTitle = (group: IBoardRankingGroup): string =>
  `${modalityLabel(group.modality)} · ${categoryLabel(group.category)}`;

/**
 * Horário de uma rodada ou intervalo do cronograma. O cronograma grava a hora
 * de parede como UTC (08:30 do evento = 08:30Z; ver utils/scheduleDate.ts),
 * então não se converte pelo fuso do navegador — senão 08:30 vira 05:30.
 */
export const formatTime = (iso: string): string => formatWallClockTime(iso);

export const formatSeconds = (seconds: number | null): string => {
  if (seconds === null || seconds === undefined) return '—';
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return m > 0 ? `${m}min ${String(s).padStart(2, '0')}s` : `${s}s`;
};
